<template>
  <VPanel class="relative p-6 overflow-hidden">
    <div class="flex justify-between">
      <h1 class="text-lg">نظرسنجی های انجام شده</h1>
    </div>
    <hr class="border-dark-line mt-6">

    <table class="w-full text-right mt-4">
      <thead>
      <tr class="text-sm text-muted">
        <th class="p-4">ردیف</th>
        <th>کاربر</th>
        <th>توضیحات</th>
        <th>عملیات</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(survey, index) in surveys"
          :key="survey.id">
        <td class="p-8">{{ index + 1 }}</td>
        <td>{{ survey.user.name }}</td>
        <td>{{ survey.description }}</td>
        <td>
          <div class="flex gap-x-2">
            <a href="#" @click.prevent="modalResult = true; surveyDetail = survey.details">
              <EyeIcon class="text-blue"/>
            </a>
          </div>
        </td>
      </tr>
      </tbody>
    </table>

    <ModalSurveyResult
        :show="modalResult"
        :survey-details="surveyDetail"
        @click="modalResult = false"
    />

  </VPanel>
</template>

<script>
import {getSurveys} from "@/API/API";
import VPanel from "@/components/VPanel";
import EyeIcon from "@/components/Icons/EyeIcon.vue";
import ModalSurveyResult from "@/components/Modal/ModalSurveyResult.vue";

export default {
  name: "SurveyView",
  components: {ModalSurveyResult, EyeIcon, VPanel},
  data() {
    return {
      surveys: [],
      modalResult: false,
      surveyDetail: {}
    }
  },
  async created() {
    this.surveys = (await getSurveys()).data
  },
}
</script>

<style scoped>

</style>